module.exports = __webpack_public_path__ + "img/99.192d34da.jpg";